export const PRICING_TIERS = [
    {
        key: 'studio',
        monthly: '€ 59',
        yearly: '€ 590',
        features: ['venues', 'spaces', 'provider', 'seats', 'trial']
    },
    {
        key: 'venue',
        monthly: '€ 149',
        yearly: '€ 1.490',
        addition: '€ 45',
        features: ['venues', 'spaces', 'provider', 'branding', 'seats'],
        highlighted: true
    },
    {
        key: 'group',
        monthly: '€ 399',
        yearly: '€ 3.990',
        features: ['venues', 'spaces', 'subaccounts', 'provider', 'seats', 'custom']
    },
    {
        key: 'licence',
        monthly: '€ 990',
        yearly: '€ 9.900',
        addition: '€ 25',
        features: ['vendors', 'install', 'data', 'provider', 'assisted'],
        licence: true
    }
];
/** The comparison the homepage ledger and the pricing page both state. */
export const PRICING_EXAMPLE = {
    bookings: '€ 3.000',
    q4s: '€ 59',
    q4sShare: '2,0 %',
    marketplace: '€ 300 – 600',
    marketplaceShare: '10 – 20 %'
};
